import { connect } from 'react-redux'
import { actions } from '@bt-react/store'
import DeleteAssetAlert from '@bt-react/components/DeleteAssetAlert'

const mapStateToProps = (state: any, props: any) => {

    return {
        activeResource: state.resources && state.resources.activeResource,
        status: state.resources && state.resources.status
    }

}

const mapDispatchToProps = (dispatch: any) => ({
    setView: (view: string, state?: boolean) =>
        dispatch(actions.resource.setAttachmentView(view, state)),
    deleteResource: (channelId: string, webcastId: string, attachmentId: string, origin: string) =>
        dispatch(actions.resource.deleteResource(channelId, webcastId, attachmentId, origin))
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAssetAlert)